import {ioJsonAction} from "Core/store/actions/io";

/**
 * Fetch the list of study types
 *
 * @param {function} [abortCallback=(abortController)=>{}] - Callback function that will receive AbortController as an
 * argument.
 * @param {string} studyId - ID of the study to get the study types for. If empty or not set, all study types will be
 * fetched.
 * @return {function(*=): Promise<IoJsonFetchResponseObject>}
 */
export const fetchStudyTypesAction = (abortCallback, studyId) => dispatch => {
	const endpoint = studyId ? 'study/fetch-study-types-by-study' : 'study/fetch-study-types';
	const payload = studyId ? {id: studyId} : null;
	
	return ioJsonAction(
		abortCallback,
		'defaultAuthorizedApi',
		endpoint,
		payload,
	)(dispatch);
};